<template>
  <transition>
    <div
      v-if="isLoading"
      class="carousel-item w-full h-full absolute top-0 left-0 object-cover z-0 bg-center bg-cover slider shimmer-box shimmer"
    >
      <!-- <div class="absolute inset-y-0 right-0 w-1/2 h-full right-shadow"></div> -->
      <!-- <div class="absolute bottom-0 inset-x-0 h-64 bottom-shadow"></div> -->

      <!-- shimmer description -->
      <div
        class="absolute bottom-[1rem] right-1/2 md:right-0 md:-translate-x-0 translate-x-1/2 my-4 md:mr-10 md:w-[600px] flex flex-col justify-center items-center md:items-start"
        dir="rtl"
      >
        <div class="flex md:justify-start justify-center items-center w-36 h-36 bg-shimmer"></div>
        <div class="hidden md:flex justify-start space-x-1 my-1">
          <div
            class="md:py-1 md:px-3 py-1 px-1 mx-1 bg-shimmer w-24 h-10 rounded-[25px]"
            v-for="n in 3"
            :key="n"
          ></div>
        </div>
        <div
          class="md:hidden flex flex-row justify-center items-center w-full space-x-1"
        >
          <div
            class="flex justify-center space-x-1 items-center bg-shimmer w-12 h-3 rounded-md mt-2 mx-1"
            v-for="n in 3"
            :key="n"
          ></div>
        </div>
        <p
          class="hidden md:block my-3 bg-shimmer h-6 w-full max-w-lg"
        ></p>
        <div class="flex md:justify-start justify-center items-center my-3">
          <div class="bg-shimmer rounded-[30px] md:px-6 md:py-2 px-3 py-2 w-32 h-10"></div>
        </div>
      </div>
      <!-- end of shimmer description -->
    </div>
    <div
      v-else
      class="carousel-item w-full h-full absolute top-0 left-0 object-cover z-0 bg-center bg-cover slider cursor-pointer"
      :style="{ backgroundImage: `url(${image(slide)})` }"
      @click="
        $router.push({ name: 'watch.now', params: { id: slide.serie_id } })
      "
    >
      <div
        class="absolute inset-y-0 right-0 w-1/2 h-full right-shadow text-white"
      ></div>
      <div
        class="absolute bottom-0 inset-x-0 h-64 bottom-shadow text-white"
      ></div>

      <!-- main description -->
      <div
        class="absolute bottom-[1rem] right-1/2 md:right-0 md:-translate-x-0 translate-x-1/2 my-4 md:mr-10 md:w-[600px] flex flex-col justify-center items-center md:items-start"
        dir="rtl"
      >
        <div
          class="flex md:justify-start justify-center items-center w-36 h-36"
        >
          <img
            :src="getLogo(slide)"
            alt="logo"
            class="object-fit"
            style="object-fit: contain !important"
          />
        </div>
        <div class="hidden md:flex justify-start space-x-1 my-1">
          <div
            class="md:py-1 md:px-3 py-1 px-1 mx-1 tag-bg border border-gray-300 rounded-[25px] text-white text-[1vw] font-medium"
            v-for="tag in slide.serie.tags"
            :key="tag.id"
          >
            {{ tag.name }}
          </div>
        </div>
        <div
          class="md:hidden text-white space-x-1 flex flex-row justify-center items-center w-full"
        >
          <div
            class="flex justify-center space-x-1 items-center"
            v-for="(tag, index) in slide.serie.tags"
            :key="tag.id"
            dir="rtl"
          >
            <span class="text-sm"> {{ tag.name }}</span>
            <span
              v-if="
                slide.serie.tags?.length > 1 &&
                index < slide.serie.tags.length - 1
              "
              class="text-4xl font-bold mb-1"
            >
              {{ "." }}
            </span>
          </div>
        </div>
        <p
          class="hidden md:block text-white my-3 text-[1vw] font-medium leading-6 z-20 max-w-lg text-right"
        >
          {{ slide.desc ? slide.desc : "" }}
        </p>
        <div class="flex md:justify-start justify-center items-center my-3">
          <router-link :to="`/watch/now/${slide.serie_id}`">
            <button
              v-show="slide.desc != 'null'"
              type="button"
              class="bg-white rounded-[30px] md:px-6 md:py-2 px-3 py-2 text-black font-semibold text-center inline-flex items-center text-xl mt-2 z-20 btn-top text-md lg:text-lg hover:bg-basic hover:text-white"

              tabindex="0"
            >
              {{ "شاهد الان" }}
              <play-svg />
            </button>
          </router-link>
        </div>
      </div>

      <!-- end of main description -->
    </div>
  </transition>
</template>

<script>
import { S3_BASE_URL } from "@/constants";
import PlaySvg from "../svg/PlaySvg.vue";
export default {
  components: { PlaySvg },

  props: ["slide","isLoading"],
  data() {
    return {
      base_url: S3_BASE_URL,
      type: "sliders",
    };
  },
  computed: {
  
  },
  methods: {
    getLogo(slide) {
      if (slide?.serie?.logo) {
        return `${this.base_url}series/${slide.serie.logo}`;
      }
    },
    image(slider) {
      if (slider.image) {
        return `${this.base_url}${this.type}/${slider.image}`;
      } else {
        return require("@/assets/" + "placeholder-wide.webp");
      }
    },
  },
  created() {
     console.log(this.isLoading);
  },
};
</script>

<style scoped>
.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.bg-shimmer {
  background: rgba(255, 255, 255, 0.1);

}

.shimmer {
  color: grey;
  display: inline-block;
  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300%
    100%;
  background-repeat: no-repeat;
  animation: shimmer 2.5s infinite;
  font-size: 50px;
}

@keyframes shimmer {
  100% {
    -webkit-mask-position: left;
  }
}

.shimmer-box {
  background: rgba(255, 255, 255, 0.1);

}

.btn-bg {
  background-color: #9d2890;
}

.text-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* Number of lines to show */
}

.focusable:focus {
  outline: 3px white;
  border-radius: 8px;
  background-color: white;
}
</style>
